//https://github.com/markedjs/marked

import css from "./index.module.css";
import Header from "../../../components/Header";
import Button from "../../../components/Button";
import Loading from "../../../components/Loading";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useEffect, useState } from "react";
import { getData } from "../../../utils/fetch";
/**
 * Displays learning content, selecteble from two <Lists /> for missions and challenges
 */
const Content = () => {
  const [missions, setMissions] = useState(null);
  const [challenges, setChallenges] = useState(null);
  const [solutionLink, setSolutionLink] = useState(null);

  useEffect(() => {
    getData("/api/challenges").then((data) => setChallenges(data));
    getData("/api/missions").then((data) => setMissions(data));
  }, []);

  return (
    <div className={css.page}>
      <Header isTeacher={true} nav="Lerninhalte" />
      <div className={css.conentContainer}>
        <div className={css.lists}>
          <List data={missions} type="Missions" setSolutionLink={setSolutionLink} />
          <List data={challenges} type="Challenges" setSolutionLink={setSolutionLink} />
        </div>
        <div className={css.content}>
          {solutionLink && <iframe
              src={"https://drive.google.com/file/d/" + solutionLink + "/preview?usp=sharing" }
            ></iframe>}
          <span>Markdown Content</span>
          <Button>
            <span>Drucken</span>
          </Button>
          <Button>
            <span>Download</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

/**
 * Renders a list of either missions or challenges. A selected Element displays in the markdown - content area
 * @param {Object} data Listelementobject
 * @param {String} name of given data: "Mission" || "Challenge" 
 */
const List = ({ data, type, setSolutionLink }) => {
  return (
    <div className={css.list}>
      {data == null && <Loading />}
      <>
        <div className={css.listHeader}>
          <span>{type}</span>
        </div>
        {data != null && data.length === 0 && <span>No {type} found </span>}

        {data != null && data.length >= 0 && (
          <div className={css.listBody}>
            {data.map((element) => {
              return (
                <div key={"contentElement_" + element.id} className={css.listElement}>
                  <span>{element.name}</span>
                  <ArrowForwardIcon onClick={() => setSolutionLink(element.solution_link_id)} />
                </div>
              );
            })}
          </div>
        )}
      </>
    </div>
  );
};

export default Content;
